import { httpRequest } from "../../http";
import { Organization } from "@models/organization.model";

export class CommandGetDefaultOrganization {
    async run(): Promise<Organization | undefined> {
        const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/organizations/default/`;
        try {
            return await httpRequest<Organization>(url);
        } catch (error) {
            console.error("Error fetching default organization:", error);
            throw error;
        }
    }
}
